import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import UseGeoLoaction from "./UseGeoLocation";
import {
    GoogleMap,
    Marker,
    DirectionsRenderer,
    InfoWindow
} from "react-google-maps";
import swal from "sweetalert";

const Map = (props) => {
    const google = window.google;

    const [selectedPark, setSelectedPark] = useState(null);
    const [postList, setPostList] = useState([]);
    const [directions, setDirections] = useState(null);
    const [origin, setOrigin] = useState(null);
    const [destination, setDestination] = useState(null);
    const [mapZoom, setMapZoom] = useState(10);
    const [dynamicCenter, setDynamicCenter] = useState(null);
    const [step, setStep] = useState("start"); 
    // "start" → selecting origin
    // "end" → selecting destination
    // "done" → both selected

    /* ================== ADDED STATES (DROPDOWN ONLY) ================== */
    const [pointA, setPointA] = useState(null);
    const [pointB, setPointB] = useState(null);
    const [pickupId, setPickupId] = useState("");
    const [dropId, setDropId] = useState("");
    const [routeInfo, setRouteInfo] = useState(null);
    const [routeCenter, setRouteCenter] = useState(null);
    /* ================================================================ */

    const DEFAULT_RADIUS_MILES = 200;
    const location = UseGeoLoaction();

    /*
 * Userने search केले आहे का?
 */
const hasSearchRequest = Boolean(
  props.searchLocationInputData &&
  props.searchLocationInputData.latitude !== "" &&
  props.searchLocationInputData.longitude !== "" &&
  props.searchLocationInputData.latitude != null &&
  props.searchLocationInputData.longitude != null
);

/*
 * Search dropdown radius.
 * If No Search then default 200 miles.
 */
const selectedRadiusMiles = useMemo(() => {
    if (!hasSearchRequest) {
        return DEFAULT_RADIUS_MILES;
    }

    const radius = Number(
        props.searchLocationInputData?.radius ||
        props.searchLocationInputData?.redius ||
        15
    );

    return Number.isFinite(radius) && radius > 0
        ? radius
        : 15;
}, [
    hasSearchRequest,
    props.searchLocationInputData,
]);


    const showLocationPermission =
    location.loaded &&
    location.error &&
    location.error.code === 1;

    /* ---------------- LOAD DATA ---------------- */
    useEffect(() => {
        if (!props.searchLocationData || props.searchLocationData.length === 0) {
            axios.get(`/api/list/post/site`, {
                params: {
                    lat: location?.coordinates?.lat,
                    lng: location?.coordinates?.lng,
                    radius: DEFAULT_RADIUS_MILES,
                },
            }).then(res => {
                if (res.data?.result) {
                    setPostList(res.data.result);
                }
            });
        }
    }, [props.searchLocationData, location]);

    /* ---------------- BASE DATA ---------------- */
    const baseData =
        props.currentLocationData?.length
            ? props.currentLocationData
            : props.searchLocationData?.length
            ? props.searchLocationData
            : postList;

    /* ---------------- MAP CENTER ---------------- */
    // const mapCenter = useMemo(() => {
    //     if (props.searchLocationInputData) {
    //         return {
    //             lat: props.searchLocationInputData.latitude,
    //             lng: props.searchLocationInputData.longitude,
    //         };
    //     }
    //     if (location.loaded) {
    //         return {
    //             lat: location.coordinates.lat,
    //             lng: location.coordinates.lng,
    //         };
    //     }
    //     return null;
    // }, [props.searchLocationInputData, location]);

    // const DEFAULT_CENTER = {
    //     lat: 37.0902,
    //     lng: -95.7129, // USA center
    // };

    const mapCenter = useMemo(() => {
        if (props.searchLocationInputData) {
            return {
                lat: Number(props.searchLocationInputData.latitude),
                lng: Number(props.searchLocationInputData.longitude),
            };
        }

        if (
            location.loaded &&
            location.coordinates?.lat !== "" &&
            location.coordinates?.lng !== "" &&
            location.coordinates?.lat != null &&
            location.coordinates?.lng != null
        ) {
            return {
                lat: Number(location.coordinates.lat),
                lng: Number(location.coordinates.lng),
            };
        }

        // Permission denied → still show map
       // return DEFAULT_CENTER;
        return null;
    }, [props.searchLocationInputData, location]);

    /* ---------------- DISTANCE ---------------- */
    const getDistanceMiles = (lat1, lng1, lat2, lng2) => {
        const R = 3958.8;
        const dLat = ((lat2 - lat1) * Math.PI) / 180;
        const dLng = ((lng2 - lng1) * Math.PI) / 180;

        const a =
            Math.sin(dLat / 2) ** 2 +
            Math.cos(lat1 * Math.PI / 180) *
            Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng / 2) ** 2;

        return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
    };

    /* ---------------- FILTER DATA ---------------- */
    const mapVisibleData = useMemo(() => {
        if (!mapCenter) {
            return [];
        }

        return baseData.filter((item) => {
            const distance = getDistanceMiles(
            mapCenter.lat,
            mapCenter.lng,
            Number(item.latitude),
            Number(item.longitude)
            );

            return distance <= selectedRadiusMiles;
        });
    }, [
        baseData,
        mapCenter,
        selectedRadiusMiles,
    ]);

    /* ---------------- OFFSET SAME LAT/LNG ---------------- */
    const OFFSET_STEP = 0.00015;

    const adjustedMapData = useMemo(() => {
        const counter = {};

        return mapVisibleData.map(item => {
            const key = `${item.latitude}_${item.longitude}`;
            counter[key] = (counter[key] || 0) + 1;
            const index = counter[key] - 1;

            let lat = Number(item.latitude);
            let lng = Number(item.longitude);

            if (index > 0) {
                const angle = index * 45 * (Math.PI / 180);
                lat += Math.cos(angle) * OFFSET_STEP;
                lng += Math.sin(angle) * OFFSET_STEP;
            }

            return {
                ...item,
                _displayLat: lat,
                _displayLng: lng,
            };
        });
    }, [mapVisibleData]);


    useEffect(() => {
        if (!adjustedMapData.length) return;

        // take first visible marker as center
        const first = adjustedMapData[0];

        setDynamicCenter({
            lat: first._displayLat,
            lng: first._displayLng,
        });
    }, [adjustedMapData]);

    /* ================= DROPDOWN DATA (ADDED) ================= */
    const dropdownData = useMemo(() => {
        if (!mapCenter) {
            return [];
        }

        return baseData.filter((item) => {
            const latitude = Number(item.latitude);
            const longitude = Number(item.longitude);

            if (
            !Number.isFinite(latitude) ||
            !Number.isFinite(longitude)
            ) {
            return false;
            }

            const distance = getDistanceMiles(
            mapCenter.lat,
            mapCenter.lng,
            latitude,
            longitude
            );

            return (
            distance <= selectedRadiusMiles &&
            ["import", "export", "dump_site"].includes(
                item.item_type?.toLowerCase()
            )
            );
        });
        }, [
        baseData,
        mapCenter,
        selectedRadiusMiles,
        ]);
    /* ========================================================= */

    /* ---------------- ZOOM CONTROL ---------------- */
    useEffect(() => {
        if (props.searchLocationInputData) setMapZoom(16);
        else if (location.loaded) setMapZoom(12);
    }, [props.searchLocationInputData, location]);

    /* ================= ROUTE FUNCTIONS (ADDED) ================= */
    const traceRoute = () => {
        if (!pointA || !pointB) {
            swal("Warning", "Please select both locations", "warning");
            return;
        }
        setOrigin(pointA);
        setDestination(pointB);
    };

    const resetRoute = () => {
        setPickupId("");
        setDropId("");
        setPointA(null);
        setPointB(null);
        setDirections(null);
        setRouteCenter(null);
        setRouteInfo(null);
        setOrigin(null);
        setDestination(null);
        setSelectedPark(null); 
    };

    useEffect(() => {
        if (!origin || !destination) return;

        const directionsService = new google.maps.DirectionsService();

        directionsService.route(
            {
                origin,
                destination,
                travelMode: google.maps.TravelMode.DRIVING,
            },
            (result, status) => {
                if (status === google.maps.DirectionsStatus.OK) {
                    setDirections(result);

                    const leg = result.routes[0].legs[0];

                    setRouteInfo({
                        distance: leg.distance?.text,
                        duration: leg.duration?.text,
                        start: {
                            lat: leg.start_location.lat(),
                            lng: leg.start_location.lng(),
                        },
                        end: {
                            lat: leg.end_location.lat(),
                            lng: leg.end_location.lng(),
                        },
                    });

                    const path = result.routes[0].overview_path;
                    const mid = Math.floor(path.length / 2);

                    setRouteCenter({
                        lat: path[mid].lat(),
                        lng: path[mid].lng(),
                    });
                }
            }
        );
    }, [origin, destination]);
    /* =========================================================== */

    /* ---------------- ICON ---------------- */
    const getIcon = (type = "") => {
        const t = type.toLowerCase().trim();
        if (t === "import") return "/images/blue.png";
        if (t === "export") return "/images/red.png";
        if (t === "dump_site") return "/images/orange.png";
        return "/images/contractor.png";
    };

    const isImport = selectedPark?.item_type === "import";
    const isExport = selectedPark?.item_type === "export";
    const isDump   = selectedPark?.item_type === "dump_site";
    const isTruck  = selectedPark?.item_type === "";

    const fullName = `${selectedPark?.first_name || ""} ${selectedPark?.last_name || ""}`;
    const cuyds = `${selectedPark?.cuyds_of_dirt_min || 0} - ${selectedPark?.cuyds_of_dirt_max || 0}`;

    const truckInfo = selectedPark?.trucks?.length
    ? selectedPark.trucks
        .map((t) => {
            const label = t.no_of_truck == 1 ? "truck" : "trucks";
            return `${t.type_of_truck} (${t.no_of_truck} ${label})`;
        })
        .join(", ")
    : "";

  // console.log("selectedPark " + JSON.stringify(selectedPark));
    /* ---------------- UI ---------------- */
    return (
        <GoogleMap zoom={mapZoom} center={dynamicCenter || mapCenter}>
            
            {/* SHOW MESSAGE ON MAP */}
            {showLocationPermission && (
                <div
                    style={{
                        position: "absolute",
                        top: "20px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        zIndex: 9999,
                        background: "#fff",
                        padding: "15px 20px",
                        borderRadius: "8px",
                        boxShadow: "0 2px 10px rgba(0,0,0,.3)",
                        textAlign: "center",
                        width: "350px",
                    }}
                >
                    <h3 style={{ margin: 0 }}>
                        Please Allow Location Permission
                    </h3>

                    <p style={{ marginTop: 10 }}>
                        Please allow location access to view nearby sites on the map.
                    </p>

                    <button
                        onClick={() => window.location.reload()}
                        style={{
                            padding: "10px 20px",
                            background: "#D6A540",
                            color: "#fff",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                        }}
                    >
                        Try Again
                    </button>
                </div>
            )}



            {adjustedMapData.map(park => (
                <Marker
                    key={`${park.id}-${park._displayLat}-${park._displayLng}`}
                    position={{
                        lat: park._displayLat,
                        lng: park._displayLng,
                    }}
                    onClick={() => setSelectedPark(park)}
                    icon={{
                        url: getIcon(park.item_type),
                        scaledSize: new google.maps.Size(40, 25),
                    }}
                />
            ))}

            {/* show site info on popu window*/} 
            {selectedPark && (
                <InfoWindow
                    position={{
                        lat: selectedPark._displayLat,
                        lng: selectedPark._displayLng,
                    }}
                    onCloseClick={() => setSelectedPark(null)}
                >
                    {/* <div>
                        <strong>{selectedPark.company_name}</strong><br />
                        <strong>{selectedPark.first_name} {selectedPark.last_name}</strong><br />
                        <strong>{selectedPark.address}</strong><br />
                        <a href={`/detail/${selectedPark.id}`}>More info</a>
                    </div> */}

                    <div>
                        {/* ✅ TITLE */}
                        <strong>
                        {(isImport || isExport)
                            ? selectedPark.projectName
                            : selectedPark.projectName || selectedPark.company_name}
                        </strong>
                        <br />

                        {/* ✅ IMPORT */}
                        {isImport && (
                        <>
                            <span>{fullName}</span><br />
                            <span>Import: {cuyds} CuYds</span><br />
                            <span>Posted: {selectedPark.created_at
                                ? new Date(selectedPark.created_at).toLocaleDateString('en-GB', {
                                    day: 'numeric',
                                    month: 'short',
                                    year: 'numeric'
                                })
                                : '-'}</span>
                        </>
                        )}

                        {/* ✅ EXPORT */}
                        {isExport && (
                        <>
                            <span>{fullName}</span><br />
                            <span>Export: {cuyds} CuYds</span><br />
                            <span>Posted: {selectedPark.created_at
                                ? new Date(selectedPark.created_at).toLocaleDateString('en-GB', {
                                    day: 'numeric',
                                    month: 'short',
                                    year: 'numeric'
                                })
                                : '-'}</span>
                        </>
                        )}

                        {/* ✅ DUMP */}
                        {isDump && (
                        <>
                            <span>{selectedPark.address}</span><br />
                            <span>Posted: {selectedPark.created_at
                                ? new Date(selectedPark.created_at).toLocaleDateString('en-GB', {
                                    day: 'numeric',
                                    month: 'short',
                                    year: 'numeric'
                                })
                                : '-'}</span>
                        </>
                        )}

                        {/* ✅ TRUCK */}
                        {isTruck && (
                        <>
                            <span>{selectedPark.address}</span><br />
                            <span>{fullName}</span><br />
                            <span>{truckInfo}</span>
                        </>
                        )}
                        <br/>
                        <a href={`/detail/${selectedPark.id}`}>More info</a>

                        <br/>

                        {/* START CHECKBOX (Point A) */}
                        {selectedPark && (
                        origin?.id === selectedPark.id || (!origin && step === "start")
                        ) && (
                        <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <input
                            type="checkbox"
                            checked={origin?.id === selectedPark.id}
                            disabled={!!origin} // lock after selecting A
                            onChange={(e) => {
                                if (e.target.checked && !origin) {
                                setOrigin({
                                    id: Number(selectedPark.id),
                                    lat: Number(selectedPark.latitude),
                                    lng: Number(selectedPark.longitude),
                                });
                                }
                            }}
                            />
                            Start Mapping Route
                        </label>
                        )}

                        {/* FINISH CHECKBOX (Point B) */}
                        {selectedPark && (
                        destination?.id === selectedPark.id ||
                        (origin && selectedPark.id !== origin.id && !destination)
                        ) && (
                        <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <input
                            type="checkbox"
                            checked={destination?.id === selectedPark.id}
                            disabled={!origin || !!destination}
                            onChange={(e) => {
                                if (
                                e.target.checked &&
                                origin &&
                                !destination &&
                                origin.id !== selectedPark.id
                                ) {
                                setDestination({
                                    id: Number(selectedPark.id),
                                    lat: Number(selectedPark.latitude),
                                    lng: Number(selectedPark.longitude),
                                });
                                setSelectedPark(null);
                                }
                            }}
                            />
                            Finish Mapping Route
                        </label>
                        )}
                                                

                           

                    </div>

                    

                </InfoWindow>
            )}

            {directions && <DirectionsRenderer directions={directions} />}

            {routeCenter && routeInfo && (
                <InfoWindow position={routeCenter}>
                    <div>
                        <strong>Distance:</strong> {routeInfo.distance}<br />
                        <strong>Duration:</strong> {routeInfo.duration}<br />
                        {/* ✅ Button */}
                        <button
                            style={{
                            marginTop: "8px",
                            padding: "6px 10px",
                            background: "#D6A540",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                            fontSize: "12px"
                            }}
                            onClick={() => {
                            const origin = `${routeInfo.start.lat},${routeInfo.start.lng}`;
                            const destination = `${routeInfo.end.lat},${routeInfo.end.lng}`;

                            const url = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}`;
                            window.open(url, "_blank");
                            }}
                        >
                            Open in Google Maps
                        </button>
                    </div>
                </InfoWindow>
            )}

            {/* SOURCE */}
            {/* <div className="address" style={{ position: "absolute", top: 0, left: "12%" }}>
                <select
                    value={pickupId}
                    onChange={(e) => {
                        const selected = dropdownData.find(p => p.id == e.target.value);
                        setPickupId(e.target.value);
                        if (selected) {
                            setPointA({
                                lat: Number(selected.latitude),
                                lng: Number(selected.longitude),
                            });
                        }
                    }}
                    style={{ width: "190px", height: "41px" }}
                >
                    <option value="">Source</option>
                    {dropdownData.map(site => (
                        <option key={site.id} value={site.id}>
                            {site.item_type} - {site.project_name} - {site.address}
                        </option>
                    ))}
                </select>
            </div> */}

            {/* DESTINATION */}
            {/* <div className="address" style={{ position: "absolute", top: 0, left: "25%" }}>
                <select
                    value={dropId}
                    onChange={(e) => {
                        const selected = dropdownData.find(p => p.id == e.target.value);
                        setDropId(e.target.value);
                        if (selected) {
                            setPointB({
                                lat: Number(selected.latitude),
                                lng: Number(selected.longitude),
                            });
                        }
                    }}
                    style={{ width: "190px", height: "41px" }}
                >
                    <option value="">Destination</option>
                    {dropdownData.map(site => (
                        <option key={site.id} value={site.id}>
                           {site.item_type} - {site.project_name} - {site.address}
                        </option>
                    ))}
                </select>
            </div> */}

            {/* BUTTONS */}
            {/* SUBMIT */}
             {/* <div className="address"
                style={{
                    boxSizing: `border-box`,
                    width: `190px`,
                    padding: `12px`,
                    height: `41px`,
                    // display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    borderRadius: `3px`,
                    fontSize: "14px",
                    outline: "none",
                    position: "absolute",
                    top: "0%",
                    // top: "1%",
                    left: "37%",
                    // boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                    fontSize: `14px`,
                    outline: `none`,
                    textOverflow: `ellipses`,
                }}
            >
                <button onClick={traceRoute} type='submit' style={{
                    padding: '8px',
                    backgroundColor: '#d6a540',
                    border: '1px solid #d6a540',
                    color: '#ffffff',
                    borderRadius: '2px'
                }}>
                    Submit
                </button>
                <button 
                    onClick={resetRoute} 
                    type="button"
                    style={{
                        padding: '8px',
                        backgroundColor: '#6c757d',
                        border: '1px solid #6c757d',
                        color: '#ffffff',
                        borderRadius: '2px',
                        cursor: 'pointer'
                    }}
                >
                    Reset
                </button>
            </div> */}

            {/* RESET BUTTON */}
            {destination && (
            <button
                className="button customButton01"
                onClick={resetRoute}
                type="button"
                style={{
                position: "absolute",
                bottom: "20px",
                left: "50%",
                transform: "translateX(-50%)",
                padding: "10px 16px",
                backgroundColor: "#d6a540",
                border: "1px solid #d6a540",
                color: "#fff",
                borderRadius: "6px",
                cursor: "pointer",
                zIndex: 10,
                boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
                }}
            >
                Reset
            </button>
            )} 
        </GoogleMap>

        
    );
};

export default Map;